import { getCCValues } from '../../localStorage';
// import efClient from '../Providers/FrontEndClient';
import httpClient from '../../httpClient';
import config from '../../../globals/config'
const loginUserService = (payload: { username: string; password: string }) => {
    let { password, username } = payload;
    let data = {
        password,
        username,
    };
    return httpClient.post(`/api/oauth/token.json`, data);
};

const obtainSupplementaryUserInfo = (payload: { email: string }) => {
    return httpClient.get(``);
};
const jwtService = () => {
    const user_id = getCCValues().CC_USER_ID;
    return httpClient.post(`/api/oauth2/eaAuthorizeAuth0`, { user_id, v1BearerToken: "" });
};

export default {
    jwtService,
    loginUserService,
    obtainSupplementaryUserInfo
};
